<template>
	<div class="home2">
		<div class="ml">
			<Button :type="type==1?'primary':''" class="" @click="xuanze(1)">商品类型</Button>
			<Button :type="type==2?'primary':''" @click="xuanze(2)">商品</Button>
		</div>
		<router-view />
	</div>
</template>
<script>
	import http from '@/http/http.js'
	export default {
		
		data() {
			return {
				type:1,
			}
		},
		methods:{
			xuanze(type){
				let _this=this
				if(type!=_this.type){
					_this.type=type
					switch (type){
						case 1:
						    this.$router.push('/alliancetj2')
							break;
						case 2:
						    this.$router.push('/alliancetj3')
							break;
						default:
							break;
					}
				}
			}
		},
		created() {
			
		}
		
	}
</script>
<style scoped="scoped">
	.home2{
		background-color: #F6F6F6;
		border-radius: 15px;
		
	}
	.ml{
		padding: 20px;
	}

</style>


// WEBPACK FOOTER //
// src/components/home/alliance/home2.vue